
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import DialogBranch from './components/DialogBranch.vue';
import { UserModule } from '../../store/modules/user';
import { getSerOrderList, serviceStatisticsDetailExport } from '../../api/statistics';
import { IPagination } from '@/types';

@Component({
  name: 'StatisticsServicerDetails',
  components: {
    DialogBranch,
  }
})
export default class extends Vue {
  private formSearch = {
    orderState: '',
    timePeriods: []
  }
  private orderState = [{
    label: '进行中',
    value: 2
  }, {
    label: '待验收',
    value: 3
  }, {
    label: '已完成',
    value: 4
  }];
  private pickerOptions:any = {
    shortcuts: [{
      text: '今天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); //
        const end = new Date(today); 
        const start = new Date(today); 
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '昨天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); 
        const end = new Date(today); 
        end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
        const start = new Date(today); 
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近7天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); 
        const end = new Date(today); 
        const start = new Date(today); 
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近30天',
      onClick(picker: any) {
     const today = new Date();
        today.setHours(0, 0, 0, 0); 
        const end = new Date(today); 
        const start = new Date(today); 
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        picker.$emit('pick', [start, end]);
      }
    }]
  }

  private branchVisible = false
  closeBranchHandle(value: boolean) {
    this.branchVisible = value;
  }

  private orderParams = {
    user_id: UserModule.getUserId,
    company_id: UserModule.getCompanyId,
    page: 1,
    size: 10
  }
  @Watch('orderParams', { deep: true, immediate: true })
  onParamsChange() {
    // 不在乎哪个变了，只要变了，就要重新请求数据
    this.getList();
  }
  handleCurrentChange(size:number) {
    this.orderParams.page = size;
  }

  handlePageSizeChange(size: number) {
    this.orderParams.size = size;
  }

  private pagination: IPagination = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  }

  // 导出Excel
  handleExport() {
    const startTime: any = this.formSearch.timePeriods ? Date.parse(this.formSearch.timePeriods[0]) / 1000 : '';
    const endTime : any = this.formSearch.timePeriods ? Date.parse(this.formSearch.timePeriods[1]) / 1000 : '';
    let params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      user_name: UserModule.getUserName,
      company_name: UserModule.getCompanyName,
      servicer_company_id: this.$route.query.servicer_company_id,
      branch_id: this.$route.query.branch_company_id,
      start_time: isNaN(startTime) ? '' : startTime,
      end_time: isNaN(endTime) ? '' : endTime,
      order_state: this.formSearch.orderState
    };
    serviceStatisticsDetailExport(params).then(res => {
      this.$confirm('是否跳转下载页面？', '跳转', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let routeData = this.$router.resolve({
          path: '/ExportTask',
          query: {}
        });
        window.open(routeData.href);
      }).catch(() => {

      });
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }

  created() {
    this.getList();
  }
  private loading = false
  private tableData = []
  getList() {
    /**
     * @apiParam {Number} user_id 用户id
     * @apiParam {Number} company_id 公司id
     * @apiParam {Number} start_time 开始时间
     * @apiParam {Number} end_time 结束时间
     * @apiParam {Number} cid 点击查询的那条公司id
     * @apiParam {Number} sid 点击查询的那条服务方id 必填
     * @apiParam {Number} order_state 进行中 2 待验收 3 已完成 4
     * @apiParam {string} page 页
     * @apiParam {string} size 大小
     */
    const startTime: any = this.formSearch.timePeriods ? Date.parse(this.formSearch.timePeriods[0]) / 1000 : '';
    const endTime: any = this.formSearch.timePeriods ? Date.parse(this.formSearch.timePeriods[1]) / 1000 : '';
    const params = {
      ...this.orderParams,
      servicer_company_id: this.$route.query.servicer_company_id,
      branch_id: this.$route.query.branch_company_id,
      start_time: isNaN(startTime) ? '' : startTime,
      end_time: isNaN(endTime) ? '' : endTime,
      order_state: this.formSearch.orderState
    };
    this.loading = true;
    getSerOrderList(params).then(res => {
      if (res && res.data && res.data.list && res.data.list.length > 0) {
        this.pagination.currentPage = parseInt(res.data.page_current);
        this.pagination.total = parseInt(res.data.count);
        this.tableData = res.data.list;
      } else {
        this.pagination.currentPage = 1;
        this.pagination.total = 0;
        this.tableData = [];
      }
      this.loading = false;
    }).catch(err => {
      this.showErrorMsg(err.msg);
      this.tableData = [];
      this.loading = false;
    });
  }

  getOrderDetail(val: any) {
    let routeData = this.$router.resolve({
      path: '/OrderServicer/todetail',
      query: {
        order_service_id: val.id,
        company_id: UserModule.getCompanyId,
      }
    });
    window.open(routeData.href);
  }
  handleSearch() {
    this.pagination.currentPage = 1;
    this.getList();
  }
  handleClear() {
    this.formSearch = {
      orderState: '',
      timePeriods: []
    };
    this.pagination.currentPage = 1;
    this.pagination.total = 0;
    this.getList();
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
}
